if (!customElements.get('rowenne-addon')) {
  customElements.define('rowenne-addon', class extends HTMLElement {
    connectedCallback() { queueMicrotask(() => this.connect()); }
    connect() {
      if (!this.isConnected || this.bound) return;
      this.form = document.getElementById(this.dataset.formId);
      if (!this.form) return;
      this.bound = true;
      this.variant = this.querySelector('[data-ra-variant]');
      this.quantity = this.querySelector('[data-ra-quantity]');
      this.toggle = this.querySelector('[data-ra-toggle]');
      this.status = this.querySelector('[data-ra-status]');
      this.money = new Intl.NumberFormat(this.dataset.locale || 'en', {style:'currency',currency:this.dataset.currency || 'USD'});
      this.onClick = e => {
        const button = e.target.closest('button');
        if (!button || button.disabled) return;
        if (button === this.toggle) {
          this.quantity.value = String(this.normalizeQuantity());
          this.dataset.selected = this.dataset.selected === 'true' ? 'false' : 'true';
        } else if (button.matches('[data-ra-plus],[data-ra-minus]')) {
          const option = this.variant.selectedOptions[0], step = Number(option.dataset.step || 1);
          this.quantity.value = String(this.normalizeQuantity() + (button.matches('[data-ra-plus]') ? step : -step));
        }
        this.update();
      };
      this.onChange = e => {
        if (e.target === this.variant) this.quantity.value = this.variant.selectedOptions[0].dataset.min || '1';
        this.quantity.value = String(this.normalizeQuantity()); this.update();
      };
      this.validate = e => {
        if (e.target !== this.form || this.dataset.selected !== 'true') return;
        if (!this.valid()) {
          e.preventDefault();e.stopImmediatePropagation();
          this.status.textContent = 'Please choose an available option and a valid add-on quantity.';
          this.quantity.focus();
        }
      };
      this.buildData = data => {
        if (this.dataset.selected !== 'true') return data;
        if (!this.valid()) throw {description:'Please check the complementary product option and quantity.'};
        const result = new FormData();
        for (const [name,value] of data.entries()) {
          if (name === 'id' || name === 'quantity' || name === 'selling_plan') result.append('items[0]['+name+']',value);
          else if (/^properties\[.*\]$/.test(name)) result.append('items[0]['+name.replace(/^properties\[/,'properties]['),value);
          else result.append(name,value);
        }
        if (!data.has('quantity')) result.set('items[0][quantity]','1');
        result.set('items[1][id]',this.variant.value);
        result.set('items[1][quantity]',String(this.quantity.valueAsNumber));
        return result;
      };
      this.form.rowenneAddOnData = this.buildData;
      this.addEventListener('click',this.onClick);this.addEventListener('change',this.onChange);
      window.addEventListener('submit',this.validate,true);this.update();
    }
    normalizeQuantity() {
      const option=this.variant.selectedOptions[0],min=Number(option.dataset.min || 1),step=Number(option.dataset.step || 1);
      const max=option.dataset.max ? Number(option.dataset.max) : Infinity;
      const value=Number.isFinite(this.quantity.valueAsNumber) ? this.quantity.valueAsNumber : min;
      return Math.min(max,Math.max(min,min+Math.round((value-min)/step)*step));
    }
    valid() {
      const option=this.variant.selectedOptions[0],q=this.quantity.valueAsNumber;
      return option && option.dataset.available === 'true' && Number.isSafeInteger(q) && q>0 && q===this.normalizeQuantity();
    }
    update() {
      const option=this.variant.selectedOptions[0],available=option.dataset.available==='true';
      const min=Number(option.dataset.min || 1),step=Number(option.dataset.step || 1);
      this.quantity.min=String(min);this.quantity.step=String(step);
      if(option.dataset.max)this.quantity.max=option.dataset.max;else this.quantity.removeAttribute('max');
      this.quantity.value=String(this.normalizeQuantity());
      if (!available) this.dataset.selected='false';
      const selected=this.dataset.selected==='true',q=this.quantity.valueAsNumber;
      this.toggle.disabled=!available;this.toggle.setAttribute('aria-pressed',String(selected));
      this.toggle.textContent=!available?'SOLD OUT':selected?'✓ ADDED':'+ ADD';
      this.querySelector('[data-ra-minus]').disabled=!available || q<=min;
      this.querySelector('[data-ra-plus]').disabled=!available || (option.dataset.max && q>=Number(option.dataset.max));
      this.quantity.disabled=!available;
      const price=Number(option.dataset.price),compare=Number(option.dataset.compare || 0);
      this.querySelector('[data-ra-price]').textContent=this.money.format(price*q/100);
      const old=this.querySelector('[data-ra-compare]');old.hidden=compare<=price;old.textContent=this.money.format(compare*q/100);
      const img=this.querySelector('[data-ra-image]');if(img && option.dataset.image)img.src=option.dataset.image;
      this.status.textContent=selected?`${q} optional ${q===1?'item':'items'} will be added with your purchase. Click ADDED to remove.`:'';
    }
    disconnectedCallback() {
      this.removeEventListener('click',this.onClick);this.removeEventListener('change',this.onChange);
      window.removeEventListener('submit',this.validate,true);
      if(this.form?.rowenneAddOnData===this.buildData)delete this.form.rowenneAddOnData;
      this.bound=false;
    }
  });
}
